import leaveInitialBalance from '@/api/human-resource/leave-initial-balance'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attributes
    )
    return leaveInitialBalance.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  generate(context, data) {
    return leaveInitialBalance.generate(data)
  },
  update(context, { id, data }) {
    return leaveInitialBalance.update(id, data)
  }
}
